import { InjectableClass } from '@fino/lib-injection';

export class FeatureFlagService extends InjectableClass {
  constructor(envService, FeatureFlagNames, $log, walkMeSnippetService, $http) {
    'ngInject';
    super({ envService, FeatureFlagNames, $log, walkMeSnippetService });
  }

  get environment() {
    return this.envService.getEnvironment();
  }

  get project() {
    return this.environment.project;
  }

  get tenant() {
    return this.environment.tenant;
  }

  get featureFlags() {
    return this.receivedFeatureFlags;
  }

  get FeatureNames() {
    return this.FeatureFlagNames;
  }

  set featureFlags(flags) {
    this.receivedFeatureFlags = flags;
  }

  isFeatureActive(feature) {
    return this.featureFlags ? this.featureFlags[feature] : false;
  }

  activateSnippets() {
    // WalkMe
    if (this.isFeatureActive(this.FeatureNames.FF_ENABLE_WALK_ME)) {
      this.walkMeSnippetService.activate();
    }
  }
}
